import React, { Fragment, useEffect, useState, useContext, useRef } from 'react';
import { TextsContext } from '../../context/textsContext';
import { TitleH2Component } from '../../components/TitleH2Component';
import { BtnComponent } from '../../components/BtnComponent';
import { TitleH1Component } from '../../components/TitleH1Component';
import { ParagraphComponent } from '../../components/ParagraphComponent';
import style from '../../scss/home.module.scss';
import { useCotizador } from '../../context/apiContext';
import StyleGrid from "../../scss/grid.module.scss";
import MenuComponent from '../../components/MenuComponent';
import { BrowserView, MobileView } from 'react-device-detect';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from 'context/userContext';
import { useAgentNumberValidation } from 'hooks/AgentNumberValidation';
import Loader from 'components/LoaderComponent';
import NavbarComponent from 'components/NavbarComponent';

const Home = () => {
  const { userdata } = useParams();
  const { loginWithUserData, logout, displayName } = useAuth();
  const { texts, verifyCurrentLanguage } = useContext(TextsContext);
  const { resetData } = useCotizador();
  const [redir, setRedir] = useState(false);

  const { validate } = useAgentNumberValidation();


  useEffect(() => {
    verifyCurrentLanguage();
  }, []);
  const hHeader = useRef(null);
  const [hamburger, sethamburger] = useState(true)

  const welcomeText = texts?.home_welcome_back ?? 'Welcome back';
  const heroTitleLine = texts?.home_phrase_one ?? 'PLANES DISEÑADOS POR TI,';
  const heroSubtitleRaw = texts?.home_phrase_two ?? 'RESPALDADO POR VUMI®';
  const heroSubtitleMarca = heroSubtitleRaw?.replace?.("®", `<span>&reg;</span>`) ?? '';
  const heroIntro = texts?.home_phrase_three
    ?? 'Con <strong>My VIP Care™</strong>, personalizas coberturas, eliges beneficios y ajustas cada detalle según lo que realmente valoras.';

  useEffect(() => {
    if (userdata) {
      validate(userdata).then((isValid) => {
        if (isValid) {
          if (!loginWithUserData(userdata)) {
            logout();
          };
        } else {
          logout();
        }
        setRedir(true);
      });
    }
  }, [userdata, loginWithUserData]);

  if (redir && window.location.pathname !== "/home") {
    return <Navigate to={"/home"} />
  }

  return (
    <Fragment>
      <NavbarComponent transparent />
      <div className={style.home}>

        <MobileView className={style.videoFondoContent}>
          <img src={'/img/fondo-video.jpg'} alt={'img fondo login'} className={style.videoFondo} />
        </MobileView>
        <BrowserView>
          <img
            src="/video/home.gif"
            alt="Fondo animado"
            className={style.video}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              objectFit: 'cover',
            }}
          />
        </BrowserView>

        <div className={style.contenido}>
          <div className={` d-md-none ${StyleGrid.wpMenu} ${!hamburger ? StyleGrid.active : null}`} ref={hHeader}>
            <div className={StyleGrid.wpScroll}>
              <MenuComponent sethamburger={sethamburger} hamburger={hamburger} menuHome />
            </div>
          </div>
            <div className={`container ${style.body_home}`}>
              <div className='row'>
                <div className='col-12 col-md-8 col-lg-7'>
                  <div className="text-center text-md-start px-2 px-md-0">
                    <TitleH2Component styleGroup={`raleway color-white ${style.welcomeBack}`}>
                      <strong>{welcomeText}</strong>
                      {displayName ? <span className={style.welcomeName}> {displayName}</span> : ''}
                    </TitleH2Component>

                    <TitleH1Component styleGroup={`raleway color-white text-uppercase ${style.heroTitle}`}>
                      <span className={style.heroTitleLine}>{heroTitleLine}</span>
                      <span className={style.heroSubtitleLine} dangerouslySetInnerHTML={{ __html: heroSubtitleMarca }} />
                    </TitleH1Component>

                    <ParagraphComponent styleGroup={`color-white ${style.heroIntro}`}>
                      <span dangerouslySetInnerHTML={{ __html: heroIntro }} />
                    </ParagraphComponent>
                  </div>

                  <div className={`d-flex justify-content-center justify-content-md-start py-4 ${style.btnGroup}`}>
                    {userdata ? <Loader /> : <>
                      <BtnComponent onClick={resetData} to={`/step1`} styleGroup="bg_primary text-white text-center">
                        {texts?.dashboard_new_quote ?? 'New Quote'}
                      </BtnComponent>
                      <BtnComponent to={`/dashboard`} styleGroup="bg_azul7 text-white text-center">
                        {texts?.dashboard_title ?? 'My Favorite Plan'}
                      </BtnComponent>
                    </>}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Home;
